import { Injectable } from '@angular/core';
import { TdMediaService } from '@covalent/core';

@Injectable()
export class MediaService {
  isMobile = this.mediaService.registerQuery('gt-sm')
  .distinctUntilChanged()
  .share()
  .startWith(this.mediaService.query('gt-sm'))
  .map(x => !x);

  isHighDefinition = this.mediaService.registerQuery('xl')
  .distinctUntilChanged()
  .share()
  .startWith(this.mediaService.query('xl'));
  constructor(
    private mediaService: TdMediaService,
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/shared-services/media.service.ts